/** The one geometry of an overlapping row of round faces: a project's team (`AvatarStack`) and the marks of
 *  `MarkStrip` (models, tools) draw the same stack, so they overlap by the same amount, wear the same
 *  card-coloured ring and share one diameter. */
export const AVATAR_STACK_SIZE = 22;
/** The row: each item overlaps the one before it. */
export const AVATAR_STACK = '-space-x-1.5';
/** Around every item: the card-coloured ring that cuts it out of its neighbour. */
export const AVATAR_STACK_RING = 'rounded-full ring-2 ring-card';
/** A disc in the stack that is not a face: a `MarkStrip` mark and the "+N" chip of either. The fill is a
 *  solid surface (never translucent, so a chip cuts cleanly out of its neighbour) and the edge is the strong
 *  border token, so a chip stays visible on every skin, including the near-black one where muted alone is
 *  barely lighter than the card behind it. The caller sizes it to the stack's diameter. */
export const AVATAR_STACK_CHIP = `flex shrink-0 items-center justify-center border border-border-strong bg-muted text-foreground ${AVATAR_STACK_RING}`;
